import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqPedidoItens = {
	listDeleted: async function (param, paramValue, paramDtIni, paramDtFim, page) {
		return apiServer
			.get("portal/v1/pedido/deletados", {
				params: {
					param,
					paramValue,
					paramDtIni,
					paramDtFim,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqPedidoItens;
